export default __webpack_public_path__ + "static/media/drip.49cbfc38.svg";